/**
 * Regras dos anexos de ideia, espelhadas do backend (euro-clic-api:
 * `IDEA_ATTACHMENT_MAX_BYTES`, `MAX_ACTIVE_IDEA_FILES` e o filtro de tipos em
 * `src/upload/upload.options.ts`). A validação que vale é a do backend; aqui
 * é só para avisar o colaborador antes de enviar.
 */
export const IDEA_ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024;
export const MAX_IDEA_ATTACHMENTS = 10;

/** Extensão → mimetypes aceitos (imagem e PDF). */
export const IDEA_ATTACHMENT_TYPES: { [extension: string]: string[] } = {
  '.jpg': ['image/jpeg'],
  '.jpeg': ['image/jpeg'],
  '.png': ['image/png'],
  '.gif': ['image/gif'],
  '.webp': ['image/webp'],
  '.bmp': ['image/bmp', 'image/x-ms-bmp'],
  '.pdf': ['application/pdf'],
};

export const IDEA_ATTACHMENT_ACCEPT = Object.keys(IDEA_ATTACHMENT_TYPES)
  .concat(...Object.keys(IDEA_ATTACHMENT_TYPES).map((k) => IDEA_ATTACHMENT_TYPES[k]))
  .join(',');

/** Pastas do bucket aceitas pelo backend para anexos de ideia. */
export const IDEA_ATTACHMENT_DIR = 'idea-premiation-files';
export const KAIZEN_ATTACHMENT_DIR = 'idea-kaizen-files';
export const KAIZEN_CARD_DIR = 'idea-kaizen-images';
